import { useEffect } from 'react';

function setMetaContent(selector, content) {
  const el = document.querySelector(selector);
  if (el) el.setAttribute('content', content);
}

/**
 * Sets document.title plus description/OG/Twitter meta tags for the current page (SPA routing
 * never reloads index.html, so these need to be kept in sync per-route for SEO). Restores the
 * previous values on unmount.
 */
export function usePageTitle(title, description) {
  useEffect(() => {
    if (!title) return;

    const previousTitle = document.title;
    document.title = title;
    setMetaContent('meta[property="og:title"]', title);
    setMetaContent('meta[name="twitter:title"]', title);

    const descriptionEl = document.querySelector('meta[name="description"]');
    const previousDescription = descriptionEl?.getAttribute('content');
    if (description) {
      setMetaContent('meta[name="description"]', description);
      setMetaContent('meta[property="og:description"]', description);
      setMetaContent('meta[name="twitter:description"]', description);
    }

    return () => {
      document.title = previousTitle;
      setMetaContent('meta[property="og:title"]', previousTitle);
      setMetaContent('meta[name="twitter:title"]', previousTitle);
      if (description && previousDescription) {
        setMetaContent('meta[name="description"]', previousDescription);
        setMetaContent('meta[property="og:description"]', previousDescription);
        setMetaContent('meta[name="twitter:description"]', previousDescription);
      }
    };
  }, [title, description]);
}

export default usePageTitle;
